import { siteConfig } from '@/config/site';

/** Tenant site name from deploy env (not vertical-specific). */
export function siteBrandName(): string {
  return siteConfig.siteName || 'this site';
}

/** Hostname or site name for legal copy. */
export function siteLabel(): string {
  try {
    return new URL(siteConfig.siteUrl).hostname;
  } catch {
    return siteBrandName();
  }
}
